import OperatingValues from './OperatingValues';

export default OperatingValues;
